import request from "@/utils/request.js";

// 到场签到
export function clockIn(data){
    let routeQuery = getQueryByUrl(window.location.href);
    return request({
        url: `/material/materialapp/api/${routeQuery.port}/clock/clockIn`,
        method: "POST",
        data
    })
}

// 离场签到
export function clockOut(data){
    let routeQuery = getQueryByUrl(window.location.href);
    return request({
        url: `/material/materialapp/api/${routeQuery.port}/clock/clockOut`,
        method: "POST",
        data
    })
}

// 查询当前仓库打卡记录
export function getCurrentClockInfo(params){
    let routeQuery = getQueryByUrl(window.location.href);
    return request({
        url: `/material/materialapp/api/${routeQuery.port}/clock/currentClock`,
        method: "GET",
        params
    })
}

// 查询最后离场打卡记录
export function getCurrentClockNotOut(params){
    let routeQuery = getQueryByUrl(window.location.href);
    return request({
        url: `/material/materialapp/api/${routeQuery.port}/clock/currentClockNotOut`,
        method: "GET",
        params
    })
}

function getQueryByUrl(url){
    let index = url.lastIndexOf('?');
    let queryString = url.slice(index + 1);

    // 初始化参数对象
    const params = {};

    // 分割参数键值对并处理
    if (!queryString) return {};
    queryString.split('&').forEach(pair => {
        const [key, value] = pair.split('=');
        if (key && value) {
            // 解码 URL 编码的字符串
            const decodedValue = decodeURIComponent(value);
            // 对包含经纬度的 JSON 格式参数进行解析
            if (key === 'deviceLatLng' || key === 'checkInLatLng') {
                params[key] = JSON.parse(decodedValue);
            } else {
                params[key] = decodedValue;
            }
        }
    });
    return params
}

// 获取当日及昨日当前用户排班信息
export function getTodayAndYesterdayUserSchedule(params){
    let routeQuery = getQueryByUrl(window.location.href);
    return request({
        url: `/material/materialapp/api/${routeQuery.port}/scheduleRecord/getTodayAndYesterdayUserSchedule`,
        method: "GET",
        params
    })
}

// 新增打卡记录，也就是上班打卡/下班打卡
export function clockRecordAdd(data){
    let routeQuery = getQueryByUrl(window.location.href);
    return request({
        url: `/material/materialapp/api/${routeQuery.port}/clockRecord/clock`,
        method: "POST",
        data
    })
}